/* eslint-disable no-eq-null */
/* eslint-disable eqeqeq */
export default function isNil(value) {
  return value == undefined || value == null;
}
